import { useCallback, useState } from 'react';

/**
 * Small toast/message helper shared by pages that show success/error banners.
 *
 * Success messages auto-clear after 3s, errors after 5s. Also exposes the raw
 * setters so callers can manage the messages directly when needed.
 */
export default function useToast() {
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    // Avoid stacking multiple timeouts when callers trigger messages repeatedly.
    let successTimeoutId;
    let errorTimeoutId;

    const clearMessages = useCallback(() => {
        if (successTimeoutId) clearTimeout(successTimeoutId);
        if (errorTimeoutId) clearTimeout(errorTimeoutId);
        setError('');
        setSuccessMessage('');
    }, []);

    const showSuccess = useCallback((msg) => {
        if (successTimeoutId) clearTimeout(successTimeoutId);
        setSuccessMessage(msg);
        setError('');
        successTimeoutId = setTimeout(() => setSuccessMessage(''), 3000);
    }, []);

    const showError = useCallback((msg) => {
        if (errorTimeoutId) clearTimeout(errorTimeoutId);
        setError(msg);
        setSuccessMessage('');
        errorTimeoutId = setTimeout(() => setError(''), 5000);
    }, []);

    return { error, successMessage, setError, setSuccessMessage, clearMessages, showSuccess, showError };
}
